import React, {Component} from 'react';
import {Alert, Button, Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row,} from 'reactstrap';

import offerValidator from '../../../helpers/offerValidator';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';
import {fetchCities, fetchCountries} from '../../../actions/geoActions';
import {
    fetchBasicOfferPrefs,
    fetchLocalizedOfferPrefs,
    fetchOffer,
    saveNewOffer,
    updateSingleOffer
} from '../../../actions/promoActions';
import {closeAlert} from '../../../actions/commonsActions';
import {GUEST, OFFER_TYPES} from '../../../helpers/constants';
import RetailersSelector from './RetailersSelector';
import CountriesSelector from './CountriesSelector';
import CitiesSelector from './CitiesSelector';
import PaymentModelsSelector from './PaymentModelsSelector';
import CurrencySelector from "./CurrencySelector";
import {I18n} from '../../../I18n/components/offer';
import 'react-table/react-table.css';
import './offer.css';
import moment from "moment";
import Datetime from "react-datetime";
import CommonValidator from "../../../helpers/CommonValidator";
import RedirectUrlTypeSelector from "./RedirectUrlTypeSelector";
import swal from "sweetalert";

class Offer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newOffer: {
                id: null,
                title: '',
                appLabel: '',
                icon: null,
                iconName: '',
                retailerIds: [],
                countryCodes: [],
                cityGeonameIds: [],
                reward: '',
                currencyId: null,
                paymentModelId: null,
                specialOffer: '',
                redirectUrlType: '',
                redirectUrl: '',
                partnerSiteUrl: '',
                rewardLimit: '',
                startDate: '',
                endDate: '',
                traderCompanyId: '',
                status: ''
            },
            currentOffer: {
                id: null,
                title: '',
                appLabel: '',
                icon: null,
                iconName: '',
                retailerIds: [],
                countryCodes: [],
                cityGeonameIds: [],
                reward: '',
                currencyId: null,
                paymentModelId: null,
                specialOffer: '',
                redirectUrlType: '',
                redirectUrl: '',
                partnerSiteUrl: '',
                rewardLimit: '',
                startDate: '',
                endDate: '',
                traderCompanyId: '',
                status: ''
            },
            editMode: false,
            backTo: null,
            selectedApp: null,
            activeField: null,
            isFormValid: false
        };
        this.validators = offerValidator(this.props.lang);
        this.commonValidator = new CommonValidator(this.validators);
    }

    componentDidMount() {
        (async () => {
            const {location, match} = this.props;
            let backTo = null;
            let selectedOffer = {...this.state.newOffer}; /// !!!!!;

            try {
                if (location && location.state && location.state.backTo) {
                    backTo = location.state.backTo;
                } else {
                    backTo = '/dashboard/promo';
                }

                if (match && match.params && match.params.offerid) {
                    const selectedOfferId = match.params.offerid;
                    const offer = await this.props.fetchOffer(selectedOfferId);
                    if (offer && offer.data) {
                        selectedOffer = {...offer.data};
                    }
                }
                this.props.fetchLocalizedOfferPrefs({
                    lang: this.props.lang
                });
                this.props.fetchBasicOfferPrefs();

                selectedOffer.traderCompanyId = this.props.company.id ? this.props.company.id : null;
                this.setState({
                    backTo: backTo,
                    newOffer: selectedOffer,
                    editMode: !!selectedOffer.id
                });
            } catch (error) {
                console.log(error);
            }
        })();
    }

    onChangeOfferStatus = (status) => {
        this.props.updateSingleOffer({
            ...this.state.newOffer,
            status: status
        }).then(() => {
            const newOffer = {...this.state.newOffer};
            newOffer.status = status;
            this.setState({
                newOffer
            })
        })
    };

    handleSubmit = event => {
        event.preventDefault();
        console.log('valid', this.isFormValid())
        if (this.isFormValid()) {
            const sendData = {
                ...this.state.newOffer,
                rewardLimit: this.state.newOffer.rewardLimit ? this.state.newOffer.rewardLimit :  null
            };
            console.log(sendData, this.state);
            if (this.state.editMode) {
                this.props.updateSingleOffer(sendData)
                    .then(offer => {
                        setTimeout(() => {
                            this.props.closeAlert();
                        }, 3000);
                        this.setState(state => ({
                            editMode: false,
                            currentOffer: state.newOffer
                        }), () => {
                            setTimeout(() => {
                                this.props.changeLocation(this.state.backTo)
                            }, 2000);
                        });
                    }, error => {
                        throw new Error(error.statusText)
                    })
            } else {
                this.props.saveNewOffer(sendData)
                    .then(offer => {
                        setTimeout(() => {
                            this.props.closeAlert();
                        }, 3000);
                        if (offer.status === 'Conflict') {
                            swal(
                                I18n[this.props.lang].offerTitleAlreadyExists,
                                "",
                                "error")
                        } else {
                            this.setState(state => ({
                                editMode: false,
                                currentOffer: state.newOffer
                            }), () => {
                                this.props.changeLocation(this.state.backTo);
                            });
                        }
                    }, error => {
                        throw new Error(error.statusText)
                    })
            }
        }
    };

    clearNewOfferState = () => {
        this.setState(state => ({
            newOffer: state.currentOffer
        }), () => {
            this.props.changeLocation(this.state.backTo);
        })
    };

    onInputChange = event => {
        let name, value;
        name = event.target.name;
        value = event.target.value;
        if (this.validators[name]) {
           this.commonValidator.checkField(name, value);
        }
        this.setState(state => ({
            newOffer: Object.keys(state.newOffer).reduce((res, key) => {
                if (key === name) {
                    let tempValue = [];
                    if (Array.isArray(state.newOffer[key])) {
                        tempValue = value.split(',');
                        tempValue = tempValue.length === 1 && tempValue[0] === '' ? [] : tempValue;
                    } else {
                        tempValue = value;
                    }
                    res[key] = tempValue;
                } else {
                    res[key] = state.newOffer[key];
                }
                return res
            }, {})
        }));
    };

    isFormValid = () => {
        let status = true;
        this.checkFieldForValid();
        Object.keys(this.validators).forEach(field => {
            if (this.validators[field].errors.length || !this.validators[field].valid) {
                status = false;
            }
        });
        this.setState({
            isFormValid: status
        })
        return status;
    };

    checkFieldForValid = () => {
        Object.keys(this.state.newOffer).forEach(field => {
            if (this.validators[field]) {
                this.formValidators(field, this.state.newOffer[field]);
            }
            if (field === 'rewardLimit'
                && this.state.newOffer.rewardLimit !== ''
                && parseInt(this.state.newOffer.rewardLimit) < parseInt(this.state.newOffer.reward)) {
                this.validators.rewardLimit.errors.push(I18n[this.props.lang].limitCanNotBeLowerThanReward);
                this.validators.rewardLimit.valid = false;
            }
            // if has limit value than endDate can be null
            // if limit disabled or null endDate should be set
            if (field === 'endDate'
                && this.state.newOffer.rewardLimit === ''
                && this.state.newOffer.endDate === '') {
                this.validators.rewardLimit.errors.push(I18n[this.props.lang].limitOrEndDateShouldBeFilled);
                this.validators.rewardLimit.valid = false;
                this.validators.endDate.errors.push(I18n[this.props.lang].limitOrEndDateShouldBeFilled);
                this.validators.endDate.valid = false;
            }
        });
    };

    formValidators = (fieldName, value) => {
        this.validators[fieldName].errors = [];
        this.validators[fieldName].state = value;
        this.validators[fieldName].valid = true;
        this.validators[fieldName].rules.forEach(rule => {
            if (rule.test instanceof RegExp) {
                if (!rule.test.test(value)) {
                    this.validators[fieldName].errors.push(rule.message);
                    this.validators[fieldName].valid = false;
                }
            } else if (typeof rule.test === 'function') {
                if (!rule.test(value)) {
                    this.validators[fieldName].errors.push(rule.message);
                    this.validators[fieldName].valid = false;
                }
            }
        });
    };

    showErrors = fieldName => {
        const validator = this.validators[fieldName];
        const result = '';
        if (validator && !validator.valid) {
            const errors = validator.errors.map((info, index) => {
                return (
                    <span className="error" key={index}>
           			 	* {info}
                        <br/>
          			</span>
                );
            });
            return <div className="error mb-2">{errors}</div>;
        }
        return result;
    };

    onIconSelect = event => {
        const file = event.target.files[0];
        if (file.size > 100000) { //100KB
            swal(
                I18n[this.props.lang].iconIsTooBig,
                "",
                "error")
        } else if (file.type !== "image/png") {
            swal(
                I18n[this.props.lang].isNotAnIcon,
                "",
                "error")
        } else {
            const newOffer = {...this.state.newOffer};
            newOffer.icon = file;
            newOffer.iconName = file.name;
            if (file) {
                this.setState({
                    newOffer
                })
            }
        }
        event.target.value = ''
    }

    onRetailersItemChange = retailers => {
        const newOffer = {...this.state.newOffer};
        const retailerIds = retailers.map(retailer => retailer.value);
        const concatedRetailerIds = retailerIds.reduce((res, elem) => {
            if (Array.isArray(elem)) {
                res = res.concat(elem);
            } else {
                res.push(elem);
            }
            return res;
        }, []);
        newOffer.retailerIds = [...concatedRetailerIds];
        this.setState({
            newOffer
        }, () => {
            this.getUpdatedLocalizedOfferPrefs();
        });
    };

    onCountriesItemChange = countries => {
        const newOffer = {...this.state.newOffer};
        const countryCodes = countries.map(country => country.value);
        const concatedCountryCodes = countryCodes.reduce((res, elem) => {
            if (Array.isArray(elem)) {
                res = res.concat(elem);
            } else {
                res.push(elem);
            }
            return res;
        }, []);
        newOffer.countryCodes = [...concatedCountryCodes];
        this.setState({
            newOffer
        }, () => {
            this.getUpdatedLocalizedOfferPrefs();
        });
    };

    onCitiesItemChange = cities => {
        const newOffer = {...this.state.newOffer};
        const cityGeonameIds = cities.map(city => city.value);
        const concatedCityGeonameIds = cityGeonameIds.reduce((res, elem) => {
            if (Array.isArray(elem)) {
                res = res.concat(elem);
            } else {
                res.push(elem);
            }
            return res;
        }, []);
        newOffer.cityGeonameIds = [...concatedCityGeonameIds];
        this.setState({
            newOffer
        });
    };

    onPaymentModelsItemChange = conditions => {
        const newOffer = {...this.state.newOffer};
        newOffer.paymentModelId = conditions.value;
        this.setState({
            newOffer
        });
    };

    onRedirectUrlTypeItemChange = redirectUrlType => {
        const newOffer = {...this.state.newOffer};
        newOffer.redirectUrlType = redirectUrlType.value;
        this.setState({
            newOffer
        });
    };

    onCurrencyItemChange = curr => {
        const newOffer = {...this.state.newOffer};
        newOffer.currencyId = curr.value;
        this.setState({
            newOffer
        });
    };

    onDateStartChange = moment => {
        const newOffer = {...this.state.newOffer};
        newOffer.startDate = moment.format('YYYY-MM-DD');
        if (newOffer.startDate.length) {
            this.formValidators(['startDate'], newOffer.startDate);
        }
        this.setState({
            newOffer
        }, () => {
            this.isFormValid();
        });
    };

    onDateFinishChange = moment => {
        const newOffer = {...this.state.newOffer};
        newOffer.endDate = moment.format('YYYY-MM-DD');
        if (newOffer.endDate.length) {
            this.formValidators(['endDate'], newOffer.rewardLimit ? newOffer.endDate : 999999); // set validator to true
        }
        this.setState({
            newOffer
        }, () => {
            this.isFormValid();
        });
    };

    getUpdatedLocalizedOfferPrefs = async () => {
        const {retailerIds, countryCodes, cityGeonameIds} = this.state.newOffer;
        await this.props.fetchLocalizedOfferPrefs({
            lang: this.props.lang,
            companyIds: retailerIds.join(','),
            countryCodes: countryCodes.join(','),
            cityGeonameIds: cityGeonameIds.join(',')
        })
    };

    clearDate = (name) => {
        const newOffer = this.state.newOffer;
        this.formValidators([name], '');
        this.setState({
            newOffer: {
                ...newOffer,
                [name]: ''
            }
        }, () => {
            this.checkFieldForValid();
        });
    };

    setActiveField = (fieldName) => {
        if (this.commonValidator.validator[fieldName]) {
            this.commonValidator.resetErrors('title');
            this.setState({
                activeField: fieldName
            })
        }
    };

    render() {
        const {lang} = this.props;
        return (
            <div className='offer'>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <section>
                            <i className="mdi mdi-border-right mr-2"></i>{I18n[lang].offerTitle}
                        </section>
                        {
                            this.state.newOffer.status ? (
                                <section className="offer__status">
                                    <span
                                        className={this.state.newOffer.status === OFFER_TYPES.DRAFT ? (
                                            `offer__status-value draft`) : (
                                            this.state.newOffer.status === OFFER_TYPES.ACTIVE ? (
                                                `offer__status-value active`
                                            ) : this.state.newOffer.status === OFFER_TYPES.CANCELED ?
                                                `offer__status-value canceled` : `offer__status-value`)
                                        }
                                    >
                                        {this.state.newOffer.status === OFFER_TYPES.DRAFT ? (
                                            I18n[lang].offerDraft) : (
                                            this.state.newOffer.status === OFFER_TYPES.ACTIVE ? (
                                                I18n[lang].offerActive) :  (
                                                    this.state.newOffer.status === OFFER_TYPES.CANCELED ? (
                                                        I18n[lang].offerCanceled) : '')
                                        )}
                                    </span>
                                    {
                                        this.state.newOffer.status === OFFER_TYPES.DRAFT ? (
                                            <Button color="primary"
                                                    onClick={() => this.onChangeOfferStatus(OFFER_TYPES.ACTIVE)}>
                                                {I18n[lang].start}
                                            </Button>
                                        ) : this.state.newOffer.status === OFFER_TYPES.ACTIVE ? (
                                            <Button color="danger"
                                                    onClick={() => this.onChangeOfferStatus(OFFER_TYPES.CANCELED)}>
                                                {I18n[lang].cancel}
                                            </Button>
                                        ) : null
                                    }
                                </section>
                            ) : null
                        }
                    </CardTitle>
                    <CardBody>
                        {/*<SingleApp*/}
                        {/*    app={this.state.selectedApp}*/}
                        {/*/>*/}
                        <Row>
                            <Col xs="12" md="12" lg="12">
                                <Form onSubmit={this.handleSubmit} className='offer__form'>
                                    <Row>
                                        <Col xs="12" md="12" lg="12">
                                            <Input type="hidden" name="id" id="id"
                                                   defaultValue={this.state.newOffer.id}/>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="12">
                                            <FormGroup className="offerFormGroup">
                                                <Label for="title">{I18n[lang].name}</Label>
                                                <Input
                                                    type="text"
                                                    name="title"
                                                    id="title"
                                                    value={this.state.newOffer.title}
                                                    onChange={this.onInputChange}
                                                    onFocus={() => this.setActiveField('title')}
                                                    required
                                                />
                                                {this.showErrors('title')}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="12">
                                            <FormGroup className="offerFormGroup">
                                                <Label for="app">{I18n[lang].appLabel}</Label>
                                                <Input
                                                    type="text"
                                                    name="appLabel"
                                                    id="appLabel"
                                                    value={this.state.newOffer.appLabel}
                                                    onChange={this.onInputChange}
                                                    onFocus={() => this.setActiveField('appLabel')}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="12">
                                            <FormGroup className="offerFormGroup">
                                                <Label>{I18n[lang].chooseAppIcon}</Label>
                                                <div className="custom-file">
                                                    <Input
                                                        type="file"
                                                        className="custom-file-input"
                                                        id="upload_icon"
                                                        accept="image/*"
                                                        onChange={this.onIconSelect}/>
                                                    <label className="custom-file-label" id="upload_icon_label" htmlFor="upload_icon">{this.state.newOffer.iconName}</label>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="12">
                                            <FormGroup className="offerFormGroup">
                                                <Label for="redirectUrlType">{I18n[lang].redirectUrlType}</Label>
                                                <RedirectUrlTypeSelector
                                                    required={true}
                                                    name="redirectUrlType"
                                                    redirectUrlTypes={this.props.basicOfferPrefs.redirectUrlTypes}
                                                    newOffer={this.state.newOffer}
                                                    onRedirectUrlTypeItemChange={this.onRedirectUrlTypeItemChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="6">
                                            <FormGroup className="offerFormGroup">
                                                <Label for="redirectUrl">{I18n[lang].redirectUrl}</Label>
                                                <Input
                                                    type="text"
                                                    name="redirectUrl"
                                                    id="redirectUrl"
                                                    value={this.state.newOffer.redirectUrl}
                                                    onChange={this.onInputChange}
                                                    required
                                                />
                                                {/*{this.showErrors('redirectUrl')}*/}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="6">
                                            <FormGroup className="offerFormGroup">
                                                <Label for="partnerSiteUrl">{I18n[lang].partnerSiteUrl}</Label>
                                                <Input
                                                    type="text"
                                                    name="partnerSiteUrl"
                                                    id="partnerSiteUrl"
                                                    value={this.state.newOffer.partnerSiteUrl}
                                                    onChange={this.onInputChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="6">
                                            <FormGroup className="offerFormGroup">
                                                <Label for="countries">{I18n[lang].countries}</Label>
                                                <CountriesSelector
                                                    required={true}
                                                    name="countries"
                                                    localizedOfferPrefs={this.props.localizedOfferPrefs}
                                                    newOffer={this.state.newOffer}
                                                    onCountriesItemChange={this.onCountriesItemChange}
                                                />
                                                {/*this.showErrors('countryCode')*/}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="12">
                                            <FormGroup className="offerFormGroup">
                                                <Label for="retailers">{I18n[lang].retailers}</Label>
                                                <RetailersSelector
                                                    required={true}
                                                    name="retailers"
                                                    localizedOfferPrefs={this.props.localizedOfferPrefs}
                                                    newOffer={this.state.newOffer}
                                                    onRetailersItemChange={this.onRetailersItemChange}
                                                />
                                                {/*this.showErrors('retailers')*/}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="12">
                                            <FormGroup className="offerFormGroup">
                                                <Label for="cityGeonameIds">{I18n[lang].cities}</Label>
                                                <CitiesSelector
                                                    required={true}
                                                    name="cityGeonameIds"
                                                    localizedOfferPrefs={this.props.localizedOfferPrefs}
                                                    newOffer={this.state.newOffer}
                                                    onCitiesItemChange={this.onCitiesItemChange}
                                                />
                                                {/*this.showErrors('cities')*/}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="12">
                                            <FormGroup className="offerFormGroup">
                                                <Label for="conditions">{I18n[lang].payoutModel}</Label>
                                                <PaymentModelsSelector
                                                    required={true}
                                                    name="conditions"
                                                    paymentModels={this.props.basicOfferPrefs.paymentModels}
                                                    newOffer={this.state.newOffer}
                                                    onPaymentModelsItemChange={this.onPaymentModelsItemChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="6" lg="6">
                                            <FormGroup className="offerFormGroup offer__reward">
                                                <Label for="reward">
                                                    {I18n[lang].reward}
                                                </Label>
                                                <Input
                                                    required
                                                    type="text"
                                                    name="reward"
                                                    id="reward"
                                                    value={this.state.newOffer.reward}
                                                    onChange={this.onInputChange}
                                                />
                                                {this.showErrors('reward')}
                                                <div className="offer__installCurrency">
                                                    <CurrencySelector
                                                        name="currency"
                                                        currencies={this.props.basicOfferPrefs.currencies}
                                                        newOffer={this.state.newOffer}
                                                        required={true}
                                                        onCurrencyItemChange={this.onCurrencyItemChange}
                                                    />
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="6" lg="6">
                                            <FormGroup className="offerFormGroup offer__limitInstall">
                                                <Label for="rewardLimit">
                                                    {I18n[lang].rewardLimit}
                                                    {this.props.basicOfferPrefs.currencies
                                                    && this.props.basicOfferPrefs.currencies.length
                                                    && this.state.newOffer.currencyId - 1 >= 0
                                                        ? `(${this.props.basicOfferPrefs.currencies[this.state.newOffer.currencyId - 1].name})`
                                                        : ''
                                                    }
                                                </Label>
                                                <Input
                                                    type="text"
                                                    name="rewardLimit"
                                                    id="rewardLimit"
                                                    value={this.state.newOffer.rewardLimit}
                                                    onChange={this.onInputChange}
                                                />
                                                {this.showErrors('rewardLimit')}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="12">
                                            <FormGroup className="offerFormGroup">
                                                <Label for="offer">{I18n[lang].payoutCondition}</Label>
                                                <Input
                                                    type="text"
                                                    name="specialOffer"
                                                    id="specialOffer"
                                                    value={this.state.newOffer.specialOffer}
                                                    onChange={this.onInputChange}
                                                />
                                                {/*this.showErrors('offer')*/}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="6" lg="6">
                                            <FormGroup className="offerFormGroup">
                                                <Label for="dateStart">{I18n[lang].dateStart}</Label>
                                                <div className='offer__dateGroup'>
                                                    <Datetime
                                                        id="startDate"
                                                        name="startDate"
                                                        className="offer-data-filter"
                                                        locale="en-gb"
                                                        timeFormat={false}
                                                        inputProps={{ placeholder: `${I18n[lang].dateFrom}`, readOnly:true }}
                                                        onChange={this.onDateStartChange}
                                                        closeOnSelect={true}
                                                        value={this.state.newOffer.startDate ?
                                                            moment(this.state.newOffer.startDate).format('DD.MM.YYYY'): ''}
                                                    />
                                                    {
                                                        this.state.newOffer.startDate ? (
                                                            <Button
                                                                onClick={() => this.clearDate('startDate')}
                                                                color="gray-500"
                                                                size="sm"
                                                                round="true"
                                                                icon="true"
                                                                title={`${I18n[lang].reset}`}
                                                            >
                                                                <i className="fa fa-times"></i>
                                                            </Button>
                                                        ) : null
                                                    }
                                                </div>
                                                {this.showErrors('startDate')}
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12" md="6" lg="6">
                                            <FormGroup className="offerFormGroup">
                                                <Label for="endDate">{I18n[lang].dateFinish}</Label>
                                                <div className='offer__dateGroup'>
                                                    <Datetime
                                                        id="endDate"
                                                        name="endDate"
                                                        className="offer-data-filter"
                                                        locale="en-gb"
                                                        timeFormat={false}
                                                        inputProps={{ placeholder: `${I18n[lang].dateTo}`, readOnly:true }}
                                                        onChange={this.onDateFinishChange}
                                                        closeOnSelect={true}
                                                        value={this.state.newOffer.endDate ?
                                                            moment(this.state.newOffer.endDate).format('DD.MM.YYYY'): ''}
                                                    />
                                                    {
                                                        this.state.newOffer.endDate ? (
                                                            <Button
                                                                onClick={() => this.clearDate('endDate')}
                                                                color="gray-500"
                                                                size="sm"
                                                                round="true"
                                                                icon="true"
                                                                title={`${I18n[lang].reset}`}
                                                            >
                                                                <i className="fa fa-times"></i>
                                                            </Button>
                                                        ) : null
                                                    }
                                                </div>
                                                {this.showErrors('endDate')}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="12">
                                            {
                                                this.state.newOffer.status === OFFER_TYPES.DRAFT ? (
                                                    <FormGroup className='offer__buttons'>
                                                        <Button color="secondary" className="ml-1"
                                                                onClick={this.clearNewOfferState}>{I18n[lang].cancel}</Button>
                                                        <Button color="primary"
                                                                type="submit"
                                                                // className={`${
                                                                //     this.isFormValid() ? '' : 'disabled'}`}
                                                        >{I18n[lang].update}</Button>
                                                    </FormGroup>
                                                ) : this.state.newOffer.status === OFFER_TYPES.ACTIVE ||
                                                    this.state.newOffer.status === OFFER_TYPES.CANCELED ? (
                                                    <FormGroup className='offer__buttons'>
                                                        <Button color="secondary"
                                                                onClick={this.clearNewOfferState}>{I18n[lang].close}</Button>
                                                    </FormGroup>
                                                ) : null
                                            }
                                            {
                                                !this.state.newOffer.status ? (
                                                    <FormGroup className='offer__buttons'>
                                                        <Button color="secondary" className="ml-1"
                                                                onClick={this.clearNewOfferState}>{I18n[lang].cancel}</Button>
                                                        <Button
                                                            color="primary"
                                                            type="submit"
                                                        >{I18n[lang].save}</Button>
                                                    </FormGroup>
                                                ) : null
                                            }
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        fetchCountries: query => dispatch(fetchCountries(query)),
        fetchCities: query => dispatch(fetchCities(query)),
        fetchLocalizedOfferPrefs: query => dispatch(fetchLocalizedOfferPrefs(query)),
        fetchBasicOfferPrefs: () => dispatch(fetchBasicOfferPrefs()),
        saveNewOffer: offer => dispatch(saveNewOffer(offer)),
        updateSingleOffer: offer => dispatch(updateSingleOffer(offer)),
        fetchOffer: id => dispatch(fetchOffer(id))
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    currentUser: state.currentUser,
    authority: state.currentUser.roles[0].authority || GUEST,
    lang: state.languageReducer.lang,
    countriesList: state.countriesList.countries,
    citiesList: state.citiesList.cities,
    localizedOfferPrefs: state.localizedOfferPrefsList.prefs,
    basicOfferPrefs: state.basicOfferPrefsList.prefs,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
});

export default connect(mapStateToProps, mapDispatchToProps)(Offer)



// WEBPACK FOOTER //
// ./src/components/Promo/Offer/Offer.js